import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import HeaderFive from '../../components/Header/HeaderFive';
import Footer from '../../components/Footer';
import FooterThree from '../../components/Footer/FooterThree';
import ContactMain from './ContactMain';

const Contact = () => {
  return (
    <>
      <HeaderFive />

      <ContactMain />

      <FooterThree />
    </>
  );
};

export default Contact;
